module.exports = __webpack_public_path__ + "ac7a77222046119bef055e7334387097.svg";